import React from 'react'
import { ReportIcon } from '../ReportIcon/ReportIcon'
import s from './MetricCard.module.scss'

export const MetricCard = ({ label, value, detail, icon, tone = 'purple' }) => (
	<article className={`${s['metric-card']} ${s[`metric-card--${tone}`] || ''}`.trim()}>
		<div className={s['metric-card__top']}>
			<div className={s['metric-card__icon']}>
				<ReportIcon name={icon} />
			</div>
			<span className={s['metric-card__label']}>{label}</span>
		</div>
		<strong className={s['metric-card__value']}>{value}</strong>
		{detail && <span className={s['metric-card__detail']}>{detail}</span>}
	</article>
)
